import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useMemo, useContext, useState, useEffect } from "react"
import { CalendarContext } from "./context"
import { AppContext } from "Views/Home/context"
import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import CreateIcon from '@material-ui/icons/Create'
import DeleteIcon from '@material-ui/icons/Delete'
import CheckIcon from '@material-ui/icons/Check'
import TextField from "@material-ui/core/TextField"
import { useOldTable as useTable } from "Hooks/table"
import { generateDateRange } from "Methods/date"
import { tableInitialVariables } from "Methods/table"
import { useInputChange } from "Hooks/basic"
import { generateMutation, generateQuery } from "Methods/query"

const useStyles = makeStyles({
    weekScheduleWrap: {
        padding: '15px 0',
    },
    weekScheduleLabel: {
        color: '#999',
        fontWeight: "bold",
        marginRight: "5px",
    },
    button: {
        margin: '0 8px',
    }
})

const table = "health_op_week_schedule"
const HealthWeekSchedule = () => {
    const classes = useStyles()
    const { currentDate } = useContext(CalendarContext)
    const [ editing, setEditing ] = useState(false)
    const { text, handleChange, clearText, setText } = useInputChange("")
    const { user } = useContext(AppContext)
    const { role } = user || {}
    const { role_name } = role || {}
    // 主编
    const isTrueEditor = role_name === "true_editor"
    const isEditor = role_name && role_name.includes('editor')
    const dateRange = useMemo(() => {
        return generateDateRange(currentDate)
    }, [currentDate])

    const initVariables = useMemo(() => {
        return {
            ...tableInitialVariables,
            limit: 1000,
            where: {
                op_time: {
                    _gte: dateRange[0],
                    _lte: dateRange[dateRange.length - 1],
                },
            },
        }
    }, [currentDate])

    const { data, onRowAdd, onRowUpdate, onRowDelete, setVariables, loading  } = useTable({
        tableName: table,
        initVariables,
        getQuery: generateQuery(table),
        addMutation: generateMutation("insert", table, [
            {name: "name", type: "String"},
            {name: "op_time", type: "timestamptz"},
        ]),
        updateMutation: generateMutation("update", table, [
            { name: "name", type: "String"},
            { name: "id", type: "Int"},
        ]),
        delMutation: generateMutation("delete", table, [
            { name: "id", type: "Int"},
        ]),
        field: ["id", "name", "op_time"],
    })

    // 换周重新获取
    useEffect(() => {
        handleEditEnd()
        setVariables(initVariables)
    }, [currentDate])

    const _data = useMemo(() => {
        return data[0] || {}
    }, [data])

    const handleSetWeekSchedule = () => {
        if(text) {
            _data.name ? onRowUpdate({
                name: text,
                id: _data.id
            }).then(() => {
                handleEditEnd()
            }): onRowAdd({
                name: text,
                op_time: currentDate
            }).then(() => {
                handleEditEnd()
            })
        } else (
            handleEditEnd()
        )
    }

    const handleDelWeekSchedule = () => {
        if (!_data.id) return
        onRowDelete({
            id: _data.id
        })
    }

    const handleEdit = () => {
        setText(_data.name)
        setEditing(true)
    }

    const handleEditEnd = () => {
        clearText()
        setEditing(false)
    }
    return (
        <Grid container alignItems="center" className={classes.weekScheduleWrap}>
            <span className={classes.weekScheduleLabel}>本周值班:</span>
            {loading ? '加载中' :
                editing ? [(
                    <TextField
                        placeholder={'请输入值班人'}
                        onChange={handleChange}
                        value={text}
                    />
                ), (
                    <IconButton className={classes.button} size="small" onClick={() => handleSetWeekSchedule()} color="primary">
                        <CheckIcon fontSize="small"/>
                    </IconButton>
                )] : [(_data.name || '暂无'), isEditor ? (
                    <IconButton className={classes.button} size="small" onClick={() => handleEdit()} color="primary">
                        <CreateIcon fontSize="small"/>
                    </IconButton>
                ) : null, isEditor ? (
                    <IconButton className={classes.button} size="small" onClick={() => handleDelWeekSchedule()} color="primary">
                        <DeleteIcon fontSize="small"/>
                    </IconButton>
                ) : null]
            }
        </Grid>
    )
}

export default HealthWeekSchedule
